/* unplugin-vue-components disabled */import { render } from "./BlockImage.vue?vue&type=template&id=76cc7d3a&scoped=true"
import script from "./BlockImage.vue?vue&type=script&lang=js"
export * from "./BlockImage.vue?vue&type=script&lang=js"

import "./BlockImage.vue?vue&type=style&index=0&id=76cc7d3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cc7d3a"]])

export default __exports__